import React from 'react';
interface ActionLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  'aria-label'?: string;
}
const base = 'inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-4 text-[0.78rem] font-medium uppercase tracking-[0.18em] transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft focus-visible:ring-offset-2 focus-visible:ring-offset-carbon min-h-[52px]';
export function PrimaryLink({
  href,
  children,
  className = '',
  ...rest
}: ActionLinkProps) {
  return <a href={href} className={`${base} bg-accent-muted text-frost shadow-aura hover:bg-accent hover:shadow-[0_0_70px_-8px_rgba(124,92,196,0.55)] border border-accent-soft/30 ${className}`} {...rest} data-id="element-1" data-mp="3gjexubebbiog">
      {children}
    </a>;
}
export function SecondaryLink({
  href,
  children,
  className = '',
  ...rest
}: ActionLinkProps) {
  return <a href={href} className={`${base} border border-silver/35 bg-transparent text-frost hover:border-silver/70 hover:bg-silver/5 ${className}`} {...rest} data-id="element-2" data-mp="37d97347be9q">
      {children}
    </a>;
}